import { render, staticRenderFns } from "./ProjectInfoTab.vue?vue&type=template&id=60af865a&"
import script from "./ProjectInfoTab.vue?vue&type=script&lang=js&"
export * from "./ProjectInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfoTab.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports